var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "QRCode", style: { width: _vm.width, height: _vm.height } },
    [
      _c("canvas", {
        ref: "canvas",
        style: { width: _vm.width, height: _vm.height },
        attrs: { id: _vm.canvasId },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }